module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/lightSecondStep-6b0ddc29e960a888ba4272651569d1dd.png";